(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Commission', Commission);

    Commission.$inject = ['$resource', 'DateUtils'];

    function Commission($resource, DateUtils) {
        var resourceUrl = 'api/commissions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
